"use strict";

var _require = require("cidr-regex"),
    v4 = _require.v4,
    v6 = _require.v6;

var re4 = v4({
  exact: true
});
var re6 = v6({
  exact: true
});

module.exports = function (str) {
  return re4.test(str) ? 4 : re6.test(str) ? 6 : 0;
};

module.exports.v4 = function (str) {
  return re4.test(str);
};

module.exports.v6 = function (str) {
  return re6.test(str);
};